class EstimateDeliveryDate extends HTMLElement {

    constructor() {
        super();
        this.render();
    }

    getData () {
        return {
            globalFrom: parseInt(this.dataset.deliveryFrom || 0, 10),
            globalTo: parseInt(this.dataset.deliveryTo || 0, 10),
            variantFrom: parseInt(this.dataset.variantFrom || 0, 10),
            variantTo: parseInt(this.dataset.variantTo || 0, 10),
            startDate: this.dataset.startDate || null
        };
    }

    // French public holidays (fixed + dynamic basic ones)
    getFrenchHolidays (year) {
        const easter = this.getEasterDate(year);

        return [
            new Date(year, 0, 1),   // New Year
            new Date(year, 4, 1),   // Labour Day
            new Date(year, 4, 8),   // Victory 1945
            new Date(year, 6, 14),  // Bastille Day
            new Date(year, 7, 15),  // Assumption
            new Date(year, 10, 1),  // All Saints
            new Date(year, 10, 11), // Armistice
            new Date(year, 11, 25), // Christmas

            // Easter-based
            easter,
            this.addDays(easter, 1),   // Easter Monday
            this.addDays(easter, 39),  // Ascension
            this.addDays(easter, 50)   // Pentecost Monday
        ];
    }

    getEasterDate (year) {
        const f = Math.floor;
        const G = year % 19;
        const C = f(year / 100);
        const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
        const I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
        const J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7;
        const L = I - J;
        const month = 3 + f((L + 40) / 44);
        const day = L + 28 - 31 * f(month / 4);
        return new Date(year, month - 1, day);
    }

    addDays (date, days) {
        const d = new Date(date);
        d.setDate(d.getDate() + days);
        return d;
    }

    isWorkingDay (date, holidays) {
        const day = date.getDay();
        const isWeekend = day === 0 || day === 6;
        const isHoliday = holidays.some(h =>
            h.getFullYear() === date.getFullYear() &&
            h.getMonth() === date.getMonth() &&
            h.getDate() === date.getDate()
        );
        return !isWeekend && !isHoliday;
    }

    addWorkingDays (startDate, days) {
        let date = new Date(startDate);
        let added = 0;
        const holidays = this.getFrenchHolidays(date.getFullYear());

        while (added < days) {
            date.setDate(date.getDate() + 1);
            if (this.isWorkingDay(date, holidays)) {
                added++;
            }
        }

        return date;
    }

    formatDay (date) {
        const locale = window.Shopify?.locale || 'fr';
        return date.toLocaleDateString(locale, {
            day: 'numeric'
        });
    }

    formatDayMonth (date) {
        const locale = window.Shopify?.locale || 'fr';
        return date.toLocaleDateString(locale, {
            day: 'numeric',
            month: 'long'
        });
    }

    formatRange (fromDate, toDate) {
        const sameMonth = fromDate.getMonth() === toDate.getMonth() && fromDate.getFullYear() === toDate.getFullYear();
        const sameYear = fromDate.getFullYear() === toDate.getFullYear();

        const fromPart = this.formatDay(fromDate);
        let toPart = this.formatDayMonth(toDate);

        // If the range crosses years, show the year on the end date for clarity
        if (!sameYear) {
            const locale = window.Shopify?.locale || 'fr';
            toPart = toDate.toLocaleDateString(locale, {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
        }

        // For same month ranges, keep only the month once (on the end date)
        if (sameMonth) {
            return `${fromPart} et le ${toPart}`;
        }

        // Different month: still only show the month on the end date (example: "23 et 4 mars")
        return `${fromPart} et le ${toPart}`;
    }

    render () {
        const el = this.querySelector('.delivery-estimate__date');
        if (!el) return;

        const { globalFrom, globalTo, variantFrom, variantTo, startDate } = this.getData();

        const totalFrom = globalFrom + variantFrom;
        const totalTo = globalTo + variantTo;

        let baseDate = new Date();

        if (startDate) {
            const parsed = new Date(startDate);
            if (!isNaN(parsed) && parsed > baseDate) {
                baseDate = parsed;
            }
        }

        const fromDate = this.addWorkingDays(baseDate, totalFrom);
        const toDate = this.addWorkingDays(baseDate, totalTo);

        el.innerText = this.formatRange(fromDate, toDate);
    }
}

window.customElements.define("delivery-estimate", EstimateDeliveryDate);